<template>
   <div id="data-list-list-view" class="data-list-container">
    <vx-card class="mb-5">
        <div class="vx-row" >
            <div class="vx-col lg:w-1/4 w-full">
            <p>{{$t('TrainingOrderNumberCourseClass')}}</p>
          <v-select
            label="ClassNo"
            v-model="search.CourseClass"
            :options="courseClass" 
            :reduce="CourseClass => CourseClass"
           
          />
            </div>
           
         
            <vs-button  class="mt-5"   @click="loadTrainee" :disabled="!search.CourseClass">{{$t('LoadTrainee')}}</vs-button>
       </div>
    </vx-card>
    <vx-card class="p-5" v-if="trainee.length>0">
     <vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="10"  :data="trainee">
        <template slot="thead">
          <vs-th sort-key="Trainee">{{$t('Trainee')}}</vs-th>
          </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.FullName }}</p>
              </vs-td>
               <vs-td>
               <vs-button v-if="search.CourseClass.CourseTypeID==2||search.CourseClass.CourseTypeID==3" type="border" color="warning" @click="GeneralPractical(search.CourseClass , tr.ID)" style="margin-left:20px">{{$t('PracticalEvaluation')}}</vs-button>
               <vs-button v-if="(search.CourseClass.CourseTypeID==2||search.CourseClass.CourseTypeID==3)&&search.CourseClass.IsCoursePracticalQuestion==true" type="border" color="warning" @click="CoursePractical(search.CourseClass , tr.ID)" style="margin-left:20px">Course practical</vs-button>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>


    </vx-card>
   </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js"; 
import moduleTraineeParticipation from "@/store/traineeParticipation/moduleTraineeParticipation.js";
import vSelect from 'vue-select';
export default {
    components:{
        Datepicker,
        vSelect
    },
    data(){
        return{
              format:"dd-MM-yyyy",
            search:{},
            trainees:[],
            currentRule:null,
        }
    },
    computed:{
       
        courseClass(){
            return  this.$store.state.courseClassList.practicalCourseClass;
        },
        trainee(){
            return this.$store.state.traineeList.trainees;
        },
    },
    methods:{
        initValues()
        {
            this.search.CourseClass={};
            this.trainees=[];
        },
         
  GeneralPractical(courseClass,traineID)
   {
     debugger
         this.$router.push({name: 'InstructorGeneralPracticalAnswer', params: { CourseClassID: courseClass.ID , TraineeID : traineID,Type:1}});
   },
    
  CoursePractical(courseClass,traineID)
   {
     debugger
         this.$router.push({name: 'InstructorGeneralPracticalAnswer', params: { CourseClassID: courseClass.ID , TraineeID : traineID,Type:2}});
   },
         loadTrainee()
        {
          debugger
            var data={};
             this.$store.state.courseClassList.search.PracticalCourseClass=this.search.CourseClass;
            data.courseClassID=this.search.CourseClass.ID;
              this.$store.dispatch("traineeList/GetTraineeByCourseClassID",data.courseClassID).then((res)=>{
              this.trainees=res.data;
            });
        },
    },
    created()
    {
       if (!moduleCourseClass.isRegistered) {
          this.$store.registerModule("courseClassList", moduleCourseClass);
         moduleCourseClass.isRegistered = true;
       }
       
      if (!moduleTrainee.isRegistered) {
          this.$store.registerModule("traineeList", moduleTrainee);
         moduleTrainee.isRegistered = true;
       }
       if (!moduleTraineeParticipation.isRegistered) {
          this.$store.registerModule("traineeParticipationList", moduleTraineeParticipation);
         moduleTraineeParticipation.isRegistered = true;
       }
       debugger;
       this.$store.dispatch("courseClassList/GetPracticalCourseClasses")
       this.currentRule =JSON.parse(localStorage.getItem("userInfo")).userRole;
       if(this.$store.state.courseClassList.search.PracticalCourseClass)
           this.search.CourseClass = this.$store.state.courseClassList.search.PracticalCourseClass;
       
    }
}
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
  .vdp-datepicker__calendar
  {
    z-index: 429!important;
  }
</style>